import { render, staticRenderFns } from "./Led.vue?vue&type=template&id=6513e47a&scoped=true"
import script from "./Led.vue?vue&type=script&lang=js"
export * from "./Led.vue?vue&type=script&lang=js"
import style0 from "./Led.vue?vue&type=style&index=0&id=6513e47a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6513e47a",
  null
  
)

export default component.exports